import { Navigate } from "react-router-dom";
import { UserRole } from "../types/user";
import useAuth from "../hooks/useAuth";
import { useEffect } from "react";
import { useLocalizedPath } from "../hooks/useLocale";

type RoleGuardProps = {
  role: UserRole | UserRole[];
  children: React.ReactNode;
};

const RoleGuard = ({ children, role }: RoleGuardProps) => {
  const { user, removeAuth } = useAuth();
  const localizedPath = useLocalizedPath();

  useEffect(() => {
    if (!user) {
      removeAuth();
    }
  }, [user, removeAuth]);

  if (!user) {
    return null;
  }

  const roles = Array.isArray(role) ? role : [role];

  if (roles.includes(user.role)) {
    return children;
  }

  return <Navigate to={localizedPath("/dashboard")} />;
};

export default RoleGuard;
